import { onBeforeMount as s, getCurrentInstance as d } from "vue";
import { track as r } from "@ds/tracking/tracking";
import { isDev as l } from "../utils/isDev.js";
function v(c, i = "deprecation-warning") {
  const { deadline: e, reason: t, replacementName: m, props: p } = c || {};
  s(() => {
    var a;
    const o = (a = d()) == null ? void 0 : a.type.name, n = !!(e && new Date(e).getTime() < Date.now());
    if (!o)
      throw new Error(
        "useDeprecation must be called from within a Vue component."
      );
    r({
      action: i,
      context: {
        deadline: e,
        deadlinePassed: n,
        name: o,
        reason: t,
        replacementName: m,
        props: p
      }
    }), l() && n && r({
      action: "remove-deprecated-export",
      context: {
        deadline: e,
        name: o,
        reason: t
      }
    });
  });
}
export {
  v as useDeprecation
};
